module.exports = __webpack_public_path__ + "static/media/bannerBg.2421a913.png";